export default {
  buttons: {
    edit_note: "Edit note",
    add_note: "Add note",
  },
  points: {
    earn_point: "Earn {{count}} point",
    earn_point_other: "Earn {{count}} points",
  },
  words: {
    optional: "optional",
  },
  error_messages: {
    missing_fields: "Please select all required fields.",
    product_unavailable: "Sold out!",
  },
};
